export default class {
	constructor(options) {
		this.defaults = {
			$el: null,
		};
		this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace = "card";
		if (this.options.$el) {
			this.$el = this.options.$el;
			this.init(true);
		}
	}

	init(bool) {
		if (bool) {
			this.$el.querySelector("figure").addEventListener("click", (e) => {
				const $link = this.$el.querySelector("a");
				if ($link) {
					$link.click();
				}
			});
		}
	}
}
